export default [
  {
    path: 'afiliados/expense-configs',
    name: 'expense-configs',
    component: () => import('./index'),
    meta: {
      visible: true,
      title: 'Cadastro de Despesas',
      breadcrumb: [
        { name: 'Home', link: 'home' },
        { name: 'Afiliados', link: 'afiliados' },
        { name: 'Configurações de Despesas' }
      ]
    }
  }
]